module.exports = __webpack_public_path__ + "img/horizontal_3_6_pp13_3009.ef5760c0.png";